import React from "react";
import styled from "styled-components";

const Formulaire = styled.div`
    display: flex;
    flex-direction: column;
    .row {
        display: flex;
        justify-content: center;
        gap: 15px;
        margin:5px 10px;
        align-items: center;
    }
    .row > label {
        text-align: center;
        width: 100px;
        padding-right: 10px;

        display: flex;
        justify-content: center;
    }
    .inputForm {
        text-align: left;
        padding: 5px;
    }
    select {
        padding: 0;
    }

    .doubleRow > input {
        width: 505px;
    }
    .error {
        color: red;
        font-weight: bold;
        font-size: 1.4rem;
        padding: 8px;
    }
`;

function FormContact({
    usage,
    dataContact,
    handleChange,
    listeEnt,
    messageError,
}) {
    return (
        <Formulaire>
            <div className="row">
                <label>Sexe *</label>
                <div>
                    <input
                        type="radio"
                        id="sexe"
                        name="sexe"
                        value="M"
                        onChange={handleChange}
                        checked={dataContact.sexe === "M" ? true : false}
                        
                    />
                    <label htmlFor="M"> Homme</label>
                </div>

                <div>
                    <input
                        type="radio"
                        id="sexe"
                        name="sexe"
                        value="F"
                        onChange={handleChange}
                        checked={dataContact.sexe === "F" ? true : false}
                        
                    />
                    <label htmlFor="F"> Femme</label>
                </div>
            </div>
            <div className="row">
                <label htmlFor="nom">Nom *</label>
                <input
                    type="text"
                    name="nom"
                    id="nom"
                    value={dataContact.nom}
                    onChange={handleChange}
                    className="inputForm"
                />

                <label htmlFor="prenom">Prénom</label>
                <input
                    type="text"
                    name="prenom"
                    id="prenom"
                    value={dataContact.prenom}
                    onChange={handleChange}
                    className="inputForm"
                />
            </div>
            <div className="row">
                {usage === "modalContact" && (
                    <>
                        <label htmlFor="entreprise">Entreprise *</label>

                        <select
                            name="entrepriseId"
                            id="entrepriseId"
                            onChange={handleChange}
                        >
                            <option value=""></option>
                            {listeEnt.map((element, index) =>
                                element[1] === dataContact.entrepriseId ? (
                                    <option
                                        key={index}
                                        value={element[1]}
                                        selected
                                    >
                                        {element[0]}
                                    </option>
                                ) : (
                                    <option key={index} value={element[1]}>
                                        {element[0]}
                                    </option>
                                )
                            )}
                        </select>
                    </>
                )}

                <label htmlFor="fonction">Fonction *</label>
                <input
                    type="text"
                    name="fonction"
                    id="fonction"
                    value={dataContact.fonction}
                    onChange={handleChange}
                    className="inputForm"
                />
            </div>
            <div className="row">
                <label htmlFor="tel1">Téléphone 1</label>
                <input
                    type="text"
                    name="tel1"
                    id="tel1"
                    value={dataContact.tel1}
                    onChange={handleChange}
                    className="inputforme"
                />

                <label htmlFor="tel2">Téléphone 2</label>
                <input
                    type="text"
                    name="tel2"
                    id="tel2"
                    value={dataContact.tel2}
                    onChange={handleChange}
                    className="inputforme"
                />
            </div>
            <div className="row">
                <label htmlFor="mail1">Mail 1</label>
                <input
                    type="email"
                    name="mail1"
                    id="mail1"
                    value={dataContact.mail1}
                    onChange={handleChange}
                    className="inputforme"
                />

                <label htmlFor="mail2">Mail 2</label>
                <input
                    type="email"
                    name="mail2"
                    id="mail2"
                    value={dataContact.mail2}
                    onChange={handleChange}
                    className="inputforme"
                />
            </div>
            <div className="doubleRow row">
                <label htmlFor="adresse">Adresse</label>
                <input
                    type="text"
                    name="adresse"
                    id="adresse"
                    value={dataContact.adresse}
                    onChange={handleChange}
                    className="inputforme"
                />
            </div>
            <div className="row">
                <label htmlFor="CP">CP</label>
                <input
                    type="text"
                    name="CP"
                    id="CP"
                    value={dataContact.CP}
                    onChange={handleChange}
                    className="inputforme"
                />

                <label htmlFor="ville">Ville</label>
                <input
                    type="text"
                    name="ville"
                    id="ville"
                    value={dataContact.ville}
                    onChange={handleChange}
                    className="inputforme"
                />
            </div>
            {messageError !== "" && (
                <span className="error">{messageError}</span>
            )}
        </Formulaire>
    );
}

export default FormContact;
